import React from 'react';
import { ReactComponent as UploadIcon } from 'assets/icons/upload_purple.svg';
import { useSelector } from 'react-redux';
import { getLocalString, localNames } from 'utils/localisation.service';
import { isKtP, isProvider } from 'utils';

const ClickUpload = ({
  fileAccepts = '.xls, .doc, PNG, JPG or GIF',
  fileLimit = 50,
}) => {

  const locales = useSelector(state => state.forms?.localeStrings);
  const user = useSelector(state => state.user.groups);
  return (
    <div className="custom-drag-upload-static__upload-area">
      <div className="flex-column align-items-center" style={{display: 'flex', flexDirection: 'row'}}>
        <UploadIcon className="mb-1" />
        <div className='ml-1'>
          <div className="d-flex align-items-center click-upload">
            <div><span>Click to upload</span> or drag and drop</div>
            {/* <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD)}</div> */}
          </div>
          <div className="d-flex file-specs">
            <div>.xls (max file size: 100MB)</div>
            {/* <div>{getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS_CLICKTOUPLOAD2)}</div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClickUpload;
